import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 申报地海关分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemCustomhouse extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * 关区名称
     */
    Name?: string;
    /**
     * 关区代码
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 申报地海关分页列表-项-表单校验
 */
export const DtoListItemCustomhouseRules = {
}

/**
 * 申报地海关分页列表-项-设置项
 */
export const DtoListItemCustomhouseMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Name",
    Label: "关区名称",
  },
  {
    Prop: "Code",
    Label: "关区代码",
  },
  {
    Prop: "FullName",
    Label: "全名",
  },
]
